import {
  checkActiveParvandeh,
  checkNotNeededService,
  generateApiUrl,
  goToRoute,
} from "@/shared/utils";
// @ts-ignore
import { includes, pathOr } from "ramda";

import { Store } from "vuex";
import { VueModule } from "vue-modules";
import Vuex from "vuex";
import { Vue as _Vue } from "vue/types/vue";
import config from "@/shared/config";
import httpService from "@/shared/http";
import { router } from "@/main";

export class StoreModule implements VueModule {
  readonly name = "store";
  store?: Store<any>;

  install(Vue: typeof _Vue) {
    Vue.use(Vuex);
    const vm = Vue.prototype;
    this.store = new Vuex.Store({
      state: {
        config: {},
        searchConfig: {},
        dynamicRouteName: null,
        registrationCoursesLoading: false,
        registrationCourses: [],
        totalIncomplete: null,
        incompleteTasks: 0,
        menuItems: [],
        userInfo: null,
        visibleSidebarMobile: false,
        minimizeSidebarDesktop: false,
        mobileHeaderTitleCount: null,
        mobileHeaderBaseRoute: null,
        mobileHeaderTitleText: null,
        showParvandehNotification: false,
        shouldRefreshCaptcha: false,
        savedAudioRecordLength: 0,
      },
      mutations: {
        updateSearchConfig(state: any, config: any) {
          let [name] = Object.keys(config);
          state.searchConfig[name] = config[name];
        },
        mutate(state: any, data: { key: string; value: any }) {
          state[data.key] = data.value;
        },
      },
      actions: {
        setAction(store: any, data: { key: string; value: any }) {
          store.commit("mutate", data);
        },
        changeSearchConfig(store: any, config: any) {
          store.commit("updateSearchConfig", config);
        },
        async getAllEnumeration(store: any, reload: any = false) {
          const url = `${config.api_url}${config.resources.getAllEnumeration}`;
          try {
            const response = await httpService.get(url, {});
            const data = pathOr([], ["data", "data"], response);
            localStorage.setItem("enumerations", JSON.stringify(data));
            if (reload) {
              window.location.reload();
            }
          } catch (error) {
            vm.$generateError(error);
          }
        },
        async getMenu(store: any) {
          try {
            // reset menu items
            store.commit("mutate", { key: "menuItems", value: [] });

            /* guidance: check not needed this service in current route */
            if (checkNotNeededService("getMenu")) return;

            const url = config.api_url + config.resources.getMenu;
            const response = await httpService.get(url);
            const data = pathOr(
              [],
              ["data", "data", "result", "data"],
              response
            );
            const dynamicRouteName = pathOr(
              null,
              ["data", "data", "result", "route_name"],
              response
            );
            store.commit("mutate", {
              key: "dynamicRouteName",
              value: dynamicRouteName,
            });
            const menuItems = data.map((x: any) => {
              if ("children" in x) {
                x.children = x.children.map((child: any) => {
                  // @ts-ignore
                  const route = router.resolve({ name: child.route_name }).href;
                  child.url = route;
                  return child;
                });
              } else {
                // @ts-ignore
                x.url = router.resolve({ name: x.route_name }).href;
              }
              if (!x.url) x.url = "#";

              return x;
            });
            store.commit("mutate", { key: "menuItems", value: menuItems });
          } catch (error) {
            vm.$generateError(error);
          }
        },
        async getMyParvandehList(store: any) {
          /* guidance: get all registration items (check store data and just call service when store data is empty) */
          try {
            store.commit("mutate", {
              key: "registrationCoursesLoading",
              value: true,
            });
            let courses = { ...store.state.registrationCourses };
            if (!courses.length) {
              // @ts-ignore
              const url = generateApiUrl(["resources", "my_parvandeh"]);
              const response = await httpService.get(url);
              courses = [...pathOr([], ["data", "data"], response)];
              await store.commit("mutate", {
                key: "registrationCourses",
                value: courses,
              });
            }

            localStorage.setItem(
              "numParvandeh",
              JSON.stringify(courses.length)
            );
          } catch (error) {
            vm.$generateError(error);
          } finally {
            store.commit("mutate", {
              key: "registrationCoursesLoading",
              value: false,
            });
          }
        },
        async getRegistrationCourses(store: any) {
          /* guidance: get all registration items (check store data and just call service when store data is empty) */
          try {
            // get my parvandeh lists
            await store.dispatch("getMyParvandehList");
            const courses = store.state.registrationCourses;

            /* guidance: check if courses length <= 1 automatic call change role service and redirect to dashboard */
            if (courses.length <= 1) {
              const course = pathOr({}, ["0"], courses);
              store.dispatch("registrationChangeRole", course);
            }
          } catch (error) {
            vm.$generateError(error);
          } finally {
            store.commit("mutate", {
              key: "registrationCoursesLoading",
              value: false,
            });
          }
        },
        async registrationChangeRole(store: any, course: any) {
          /* guidance: change user role by registration code */
          try {
            store.commit("mutate", {
              key: "registrationCoursesLoading",
              value: true,
            });
            const code = pathOr(null, ["code"], course);
            const province = pathOr({}, ["hozeh_ghazayi_province"], course);
            const status = pathOr(null, ["parvandeh_status", "id"], course);
            const url = config.api_url + config.resources.change_role;
            const response = await httpService.put(url, { code });
            const hasNotParvandeh = pathOr(
              null,
              ["data", "data", "has_not_parvandeh"],
              response
            );
            if (hasNotParvandeh) {
              vm.$notify.warning(response.data.message);
            }
            localStorage.setItem(
              "activeParvandeh",
              JSON.stringify({ code, province, status })
            );
            const afterLoginRoute =
              localStorage.getItem("afterLoginRoute") || "dashboard";
            goToRoute(afterLoginRoute, {}, {}, false);
            return;
          } catch (error) {
            vm.$generateError(error);
          } finally {
            store.commit("mutate", {
              key: "registrationCoursesLoading",
              value: false,
            });
          }
        },
        async getParvandehStatus(store: any, getParvandehCode: any) {
          const activeParvandehData = { ...checkActiveParvandeh(false) };
          const currentParvanehCode = pathOr(
            null,
            ["code"],
            activeParvandehData
          );
          if (!getParvandehCode && !currentParvanehCode) {
            return vm.$notify.warning(
              "هیچ پرونده‌ای جهت دریافت وضعیت تعیین نشده است"
            );
          }
          const parvandehCode = getParvandehCode || currentParvanehCode;
          // eslint-disable-next-line no-useless-catch
          try {
            const url =
              config.api_url +
              config.profileServices.parvandeh_status_count_incomplete.replace(
                "{0}",
                parvandehCode
              );
            const response = await httpService.get(url);
            const data = pathOr({}, ["data", "data"], response);
            const totalIncomplete = pathOr(
              null,
              ["total_incomplete_item"],
              data
            );
            const incompleteTasks = pathOr(0, ["incomplete_tasks"], data);
            store.commit("mutate", {
              key: "totalIncomplete",
              value: totalIncomplete,
            });
            store.commit("mutate", {
              key: "incompleteTasks",
              value: incompleteTasks,
            });
          } catch (error) {
            const statusCode = pathOr(null, ["response", "status"], error);
            statusCode !== 403 && vm.$generateError(error);
            throw error;
          }
        },
        async putTags(store: any, payload) {
          // eslint-disable-next-line no-useless-catch
          try {
            // @ts-ignore
            const url = generateApiUrl(["resources", "tag"]);
            const response = await httpService.put(url, payload);
            vm.$notify.success(response.data.message);
          } catch (error) {
            throw error;
          }
        },
      },
      getters: {
        dynamicRouteName: (state: any) => state.dynamicRouteName,
        registrationCoursesLoading: (state: any) =>
          state.registrationCoursesLoading,
        registrationCourses: (state: any) => state.registrationCourses,
        totalIncomplete: (state: any) => state.totalIncomplete,
        incompleteTasks: (state: any) => state.incompleteTasks,
        menuItems: (state: any) => state.menuItems,
        userInfo: (state: any) => state.userInfo,
        visibleSidebarMobile: (state: any) => state.visibleSidebarMobile,
        minimizeSidebarDesktop: (state: any) => state.minimizeSidebarDesktop,
        mobileHeaderTitleCount: (state: any) => state.mobileHeaderTitleCount,
        mobileHeaderBaseRoute: (state: any) => state.mobileHeaderBaseRoute,
        mobileHeaderTitleText: (state: any) => state.mobileHeaderTitleText,
        showParvandehNotification: (state: any) =>
          state.showParvandehNotification,
        shouldRefreshCaptcha: (state: any) => state.shouldRefreshCaptcha,
        savedAudioRecordLength: (state: any) => state.savedAudioRecordLength,
      },
    });
  }
}
